export const baseColor = "#1b2047";

export const highlightColor = "#040721";

export const loginSignUpBaseColor = "#1b2047";

export const loginSignUpHighlightColor = "#040721";

export const cardbaseColor = "#565894";

export const cardhighlightColor = "#35365c";

export const loaderbaseColor = "#eeeeee";

export const loaderhighlightColor = "#cccccc";

export const boostedCardColor = "rgba(255, 255, 255, 0.08)";
